import React from "react";
import { ReactComponent as InfoIcon } from "../Assets/info.svg";

const SurveyFormTotals = ({ totalPrice, isInfoOnFeesAvailable, onModalClick }) => {
  return (
    <div className="grid grid-cols-10 gap-2 mb-3 pt-0 p-2 text-center items-end max-w-[700px] print:m-auto">
      <div className="col-span-7">
        {isInfoOnFeesAvailable && (
          <button
            onClick={onModalClick}
            className="px-2 py-1 pr-3 border border-lui-sea rounded text-lui-sea hover:bg-lui-iceberg grid grid-cols-1 grid-flow-col print:hidden"
          >
            <InfoIcon width={24} className="antialiased stroke-none fill-lui-sea" />
            <span className="font-semibold">&nbsp;Info on fees</span>
          </button>
        )}
      </div>
      <div className="col-span-3">
        <span className="text-xs font-bold">Total Plan Fees</span>
        <input
          type="text"
          value={"$" + totalPrice.toFixed(2)}
          disabled={true}
          className="w-full p-2 border border-gray-300 rounded text-end cursor-not-allowed"
        />
      </div>
    </div>
  );
};

export default SurveyFormTotals;
